import {Injectable} from '@angular/core';
import {Router, RoutesRecognized} from '@angular/router';
import {filter, pairwise} from 'rxjs';

const SKIDEO_LANDING = 'https://skideo.com';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private previousUrl?: string;

  constructor(private readonly router: Router) {
    this.router.events
      .pipe(
        filter((event): event is RoutesRecognized => event instanceof RoutesRecognized),
        filter(event => /^\/callback/.test(event.urlAfterRedirects) === false), // Filter out the /callback routes that should not be stored.
        pairwise(),
      )
      .subscribe(([prevRoute, currRoute]) => (this.previousUrl = prevRoute.urlAfterRedirects));
  }

  // If preceding page is a recognised route, navigate back (and preserve scroll + state when cached).
  // Else: navigate to Skideo landing page.
  public back(): void {
    if (this.previousUrl !== undefined) {
      this.router.navigate([this.previousUrl]);
    } else {
      location.href = SKIDEO_LANDING;
    }
  }
}
